/**
 * One field of multiple fields of this product/form 
 */
var Field = function(product, key, options)
{
	/**
	 * Reference to the object itself 
	 */
	var _this = this;
	
	/**
	 * Save the options 
	 */
	this.options = options;
	
	/**
	 * Parent object, one of the type Product 
	 */
	this.product = product;
	
	/**
	 * The key of this field, other fields can find this field by its key 
	 */
	this.key = key;
	
	/**
	 * Current value of the field 
	 */
	this.value;
	
	/**
	 * The minimal value of this field 
	 */
	this.min = options.min;
	
	/**
	 * The maximal value of this field 
	 */
	this.max = options.max;
	
	/**
	 * DOM element of this field, the element which needs to be updated with new values 
	 */
	this.elm = options.elm;
	
	/**
	 * The way of calculating the right value for this field, string name of a function in the Calculator object 
	 */
	this.calculation = options.calculation;
	
	/**
	 * The way of formatting this field when a new value is known, string name of a function in the Formatter object
	 */
	this.format = options.format ? options.format : this.product.formatter._default;
	
	/**
	 * Array with names of other fields of this product which needs to be updated after this fields event has triggered 
	 */
	this.after = options.after ? options.after : [];
	
	/**
	 * The events this field should react on 
	 */
	this.events = options.events ? options.events : 'blur';
	
	/**
	 * Function which needs to be executed after the user has triggered one of the events for the first time 
	 */
	this.beforeSave = options.beforeSave;
	
	/**
	 * Whether and event should be triggered when the field is focussed 
	 */
	this.focusEvent = options.focus === false ? options.focus : true;
	
	/**
	 * Whether to save on startup, if false update will be triggered 
	 */
	this.saveOnStartup = options.saveOnStartup ? options.saveOnStartup : false;
	
	
	this.afterUpdate = options.afterUpdate ? options.afterUpdate : [];
	/**
	 * Stack of this field, all the function which need to be performed after eachother 
	 */
	this.stack = {
		
		/**
		 * Whether this stack currently is running 
		 */
		runnning: false,
		
		/**
		 * The function which needs to be performed before the stack is empty 
		 */
		items: [],
		
		/**
		 * Add a new  function to the end of this stack 
		 */
		append: function(items){
			console.log('Field: stack: append ' + items);
			_this.stack.items = _this.stack.items.concat(items);
		},
		
		/**
		 * Add a new function to the front of this stack 
		 */
		prepend: function(items){
			console.log('Field: stack: prepend ' + items);
			_this.stack.items = items.concat(_this.stack.items);
		},
		
		/**
		 * Makes the stack start with running it first function 
		 */
		start: function(forced){
			_this.stack.forced = forced ? forced : false;
			console.log('stack.start');
			if(!_this.stack.running) {
				_this.stack.running = true;
				_this.product.activeStack = _this.stack;
				_this.stack.run();
			}
		},
		
		stop: function() {
			console.log('Stack: force stop');
			_this.stack.running = false;
			_this.stack.items = [];
		},
		
		/**
		 * Called all the time to run the next function of the stack (only works if the stack is 'running') 
		 */
		run: function(){
			if(_this.stack.items.length > 0) {
				var curr = _this.stack.items[0];
				_this.stack.items.splice(0, 1);
				console.log('Field: stack: run ' + curr);
				if(typeof curr == 'function') {
					curr.apply(_this, [_this.stack.run, _this.product.calculator.get(_this.key), _this.stack.forced]);
				} else {
					_this.product.fields[curr].calc(_this.stack.run);
				}
			} else {
				console.log("Stack: stop running");
				_this.stack.running = false;
			}
		}
	}
	
	/**
	 * When creating this field 
	 */
	this.init = function()
	{
		// Bind the given events to the field
		$(this.elm).bind(this.events, function(event){
			_this.save(event);
		});
		
		// Bind the focus event to the field when focusEvent is true
		if(this.focusEvent) {
			$(this.elm).bind('focus', function(event){
				_this.focus(event);
			});
		}
		
		// When there is already a value in the field, save it
		if(this.options.value) {
			if(this.saveOnStartup) {
				this.save(true);
			} else {
				this.update(this.options.value);
			}
		}
	}
	
	/**
	 * When the user has triggered on of the bind events 
	 */
	this.save = function(event)
	{
		
		// Get the right value of the format of this field
		var value = this.format.get($(this.elm));

		// Check the minimal and maximal values of this field
		if(this.min) {
			if(typeof this.min == 'string') {
				var result = eval(this.min);
				if(value < result)
					value = result;
			} else if (typeof this.min === 'function') {
				value = this.min(value);
			} else if(value < this.min)
				value = this.min;
		}
		if(this.max) {
			if(typeof this.max == 'string') {
				var result = eval(this.max);
				if(value > result)
					value = result;
			} else if (typeof this.max === 'function') {
				value = this.max(value);
			} else if(value > this.max)
				value = this.max;
		}
		
		// Put the value of the field in the right format
		this.format.set($(this.elm), value, this.product.fields);
		
		// Only do calculations when value has changed
		if(value != this.value || event === true) // By giving true to this function you can force a save
		{
			this.value = value;
			console.log('Field: save ' + this.key);
			this.product.calculator.set(this.key, value);
			this.stack.append(this.after);
			
			// When this field has an action before saving execute it
			if(this.beforeSave)
			{
				console.log('Field: before save ' + this.key);
				// Function to edit the value or do other actions before saving, 
				// returning true will quit saving
				if(this.beforeSave(value)) {
					this.stack.stop();
					return;
				}
			}
			console.log('start');
			this.stack.start(event === true);
		}
	}
	
	/**
	 * When the field is focussed and has a focus value
	 */
	this.focus = function(e)
	{
		$(this.elm).val(this.format.get($(this.elm)));
		$(this.elm).filter(":visible").selectRange($(this.elm).val().length, $(this.elm).val().length);
		
	}
	
	/**
	 * Update the field with a new value 
	 */
	this.update = function(value)
	{
		console.log('Field: update ' + this.key);
		if(typeof value == 'undefined')
			value = this.value;
		this.product.calculator.set(this.key, value);
		this.value = value;
		this.format.set($(this.elm), value, this.product.fields);
		this.stack.append(this.afterUpdate);
		this.stack.start();
		return this;
	}
	
	/**
	 * Calculate a new value based on other value's which probably have changed
	 */
	this.calc = function(callback)
	{
		console.log('Field: calculate ' + this.key);
		this.product.calculator[this.calculation](function(value){
			_this.update(value);
			callback();
		});
	}
	
}